import { FC } from "react"
import { PurchaseContainer } from "./PurchaseContainer"
import styled from "styled-components"
import { white } from "../components/colors"

const Container = styled.div`
  color: ${white};
  overflow-y: auto;
  height: 100dvh;
  width: 100vw;
  padding-top: 100px;
`
export const UpgradeSubscription: FC<{ onCancel: () => void}> =  ({ onCancel }) => {
  return (
      <Container>
        <div style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '800px', paddingBottom: '50px' }}>
          <PurchaseContainer purchaseType={'upgrade'} onAccessGranted={() => {
            setTimeout(() => {
              window.location.reload()
            }, 1000)
          }} onCancel={onCancel} />
        </div>
      </Container>
  )
}